const getShowGamePrototypes = state => state.appSessionReducer.showGamePrototypes;
const getSelectedProduct = state => state.appSessionReducer.product;
const getHasUserInteracted = state => state.appSessionReducer.hasUserInteracted;

export default getShowGamePrototypes;
export { getShowGamePrototypes, getSelectedProduct, getHasUserInteracted };
